import script from "./MatchRecorderView.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchRecorderView.vue?vue&type=script&setup=true&lang=js"

import "./MatchRecorderView.vue?vue&type=style&index=0&id=dce6a7b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dce6a7b6"]])

export default __exports__